import { logException } from "@sazka/utils/logger/use-app-logger";
import {
    MessageBonusomatPointsChangeDto,
    MessageFurrySpinPointsChangeDto,
    MessageGoldenWheelPointsChangeDto,
    MessageNotificationDto,
    WorkerMessage,
    WorkerMessageDataType,
} from "@sazka/websocket/notifications/models/worker-message-dto";
import { MessageLiveDealerTablesDto } from "@sazka/websocket/notifications/websocket/models/live-dealer-tables";
import { useNotificationPopup } from "@sazka/shared-components/notification-popup/use-notification-popup";
import { loadCasinoModule } from "@sazka/casino/js/core/use-ng-casino";
import { useLiveDealerCards } from "@/live-dealer/widgets/ld-product-cards/live-dealer-cards";
import { useLoyaltyPlayerStatus } from "@/loyalty/composables/use-loyalty-player-status";

const { updateCards } = useLiveDealerCards();

const { bonusomatPlayerStatus, fsPlayerStatus, gwPlayerStatus } = useLoyaltyPlayerStatus();

export const handleNotificationEvent = async (message: WorkerMessage<WorkerMessageDataType>) => {
    try {
        switch (message.name) {
            case "Notification": {
                try {
                    const messageData = message.data as MessageNotificationDto;
                    // live-dealer notification
                    if (messageData.type === "live-dealer") {
                        const { useNgCasino } = await loadCasinoModule();
                        if (!useNgCasino().isLiveDealerGameOpen.value) {
                            return;
                        }
                        useNotificationPopup({
                            ...messageData,
                            variant: "image",
                            imageUrl: "/frontend/web/img/notifications/madam-piky.png",
                        });
                    } else {
                        useNotificationPopup({ ...messageData });
                    }
                } catch (err) {
                    logException("notifications-window", err, {
                        message: "Process-notification error",
                        ...message.data,
                    });
                }
                return;
            }
            case "BonusomatPointsChange": {
                const bonusomatData = message.data as MessageBonusomatPointsChangeDto;
                bonusomatPlayerStatus.updateBonusomatPoints(bonusomatData.totalPoints);
                return;
            }
            case "GoldenWheelPointsChange": {
                const goldenWheelData = message.data as MessageGoldenWheelPointsChangeDto;
                gwPlayerStatus.updateGwPoints(goldenWheelData.totalPoints);

                return;
            }
            case "LiveDealerTables": {
                const liveDealerTablesData = message.data as MessageLiveDealerTablesDto;
                updateCards(liveDealerTablesData.tables);
                return;
            }
            case "FurrySpinPointsChange": {
                const data = message.data as MessageFurrySpinPointsChangeDto;
                fsPlayerStatus.updateFsPoints(data.totalPoints);
                return;
            }

            default:
                return;
        }
    } catch (err) {
        logException("notifications-window", err, {
            message: "Process-notification error",
            notificationName: message.name,
        });
    }
};
